<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="toc"><a class="xref" href="#/chiporter0006#intro">Introduction</a></p>
<p class="toc1"><a class="xref" href="#/chiporter0007#ut01"><i>Gà Ta</i>, Our Chicken</a></p>
<p class="toc"><a class="xref" href="#/chiporter0008#ch01">1   Experimental Entrepreneurs</a></p>
<p class="toc1"><a class="xref" href="#/chiporter0009#ut02">Hatching</a></p>
<p class="toc"><a class="xref" href="#/chiporter0010#ch02">2   Enumerating Immunity</a></p>
<p class="toc"><a class="xref" href="#/chiporter0011#ch03">3   Commerce and Containment</a></p>
<p class="toc1"><a class="xref" href="#/chiporter0012#ut03">Sacrifice</a></p>
<p class="toc"><a class="xref" href="#/chiporter0013#ch04">4   Marketing Morals</a></p>
<p class="toc"><a class="xref" href="#/chiporter0014#ch05">5   How to Own a Virus</a></p>
<p class="toc"><a class="xref" href="#/chiporter0015#conc">Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/chiporter0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiporter0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiporter0018#refs">List of References</a></p>
<p class="tocbm"><a class="xref" href="#/chiporter0019#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-porter-0005.vue?047cb49a